import { CollectionModel } from '@shared/models/restapi/Collection.Model';
import { ScheduleDeviceResultModel } from '@em/models/restapi/ScheduleDeviceResult.Model';

export class ScheduleDeviceResultCollectionModel extends CollectionModel<ScheduleDeviceResultModel> {
    public constructor() {
        super(ScheduleDeviceResultModel);
    }
}
